export default "__VITE_ASSET__BREsf0oA__"